








import axios from 'axios';
import { PAGE_MGR_CLEAR, AUTH_LOGOUT } from '@/main/store/actionTypes';
import { types } from '@/main/store/external/types';

import { DmsBaseComponent } from '#components/dms/common/base';

export default DmsBaseComponent.extend({
	name: 'ExternalModule',
	props: {
		externalModuleName: {
			type: String,
			required: true,
		},
		url: {
			type: String,
			required: true,
		},
	},
	methods: {
		async executeExternalModuleAction(event: MessageEvent) {
			if (typeof event?.data !== 'string') {
				return;
			}

			const [eventType, eventData] = event.data.split('@');

			/* eslint-disable no-case-declarations */
			switch (eventType) {
				case 'router-replace':
					const [url] = eventData.split('d=');
					window.history.replaceState({}, '', url);
					break;

				case 'menu-permissions':
					const permissions = eventData;
					this.$store.commit(`external/${types.mutations.SET_EXTERNAL_MODULES_PERMISSIONS}`, JSON.parse(permissions));
					break;

				case 'route-breadcrumbs':
					const breadcrumbs = JSON.parse(eventData);

					// clear crumbs and replace all of them
					this.$store.commit(`external/${types.mutations.REPLACE_EXTERNAL_CRUMBS}`, breadcrumbs);
					await this.$store.dispatch(`pageManager/${PAGE_MGR_CLEAR}`);
					break;

				case 'log':
					console.log(eventData);
					break;

				case 'error':
					console.log(eventData);
					console.error(JSON.parse(eventData));
					break;

				case 'finish-logout':
					if (eventData === 'mismatch') {
						const message = this.$store.state.external.resource?.message?.mismatch;
						const logout = await this.showConfirm({ message: message || 'login-mismatch' });
						if (!logout) {
							this.$router.back();
							return;
						}
					}

					window.localStorage.removeItem('EXTERNAL_MODULE_DATA');
					await this.$store.dispatch(AUTH_LOGOUT);
					break;

				case 'finish-login':
					const redirectUrlWithoutReturnUrl = eventData.split('&')[0];

					const token = await axios.get('/DMSAPI/extApi/OjeteVozy/Token/UserInfo');

					let finalUrl = `?finalUrl=${window.location.pathname.includes('OjeteVozy')
						? window.location.pathname.split('?')[0]
						: '/OjeteVozy/Sklad/List'}`;

					finalUrl = finalUrl.includes('OnLogin')
						? '?finalUrl=/OjeteVozy/Sklad/List'
						: finalUrl;

					finalUrl = finalUrl.endsWith('?') ? finalUrl.substring(0, finalUrl.length - 1) : finalUrl;
					const returnUrl = encodeURI(`${window.location.origin}/OjeteVozy/OnLogin${encodeURI(finalUrl)}`);

					const [protocol] = this.api.split('//');
					let [, api] = this.api.split('//');
					api = api.endsWith(`/${this.externalModuleName}`) ? api.split(`/${this.externalModuleName}`)[0] : api;

					window.location.replace(`${protocol}//${api}${redirectUrlWithoutReturnUrl}&returnUrl=${returnUrl}&token=${token.data}`);
					break;

				default:
			}
		},
	},
	computed: {
		api() {
			return this.$store.state.external.api;
		},
		tenant() {
			return this.$store.state.external.tenant;
		},
	},
	destroyed() {
		window.removeEventListener('message', this.executeExternalModuleAction);
	},
	created() {
		window.addEventListener('message', this.executeExternalModuleAction);
	},
});
